<button
    type="button"
    class="campaign__action btn btn--paybee btn--outline-transparent"
    placement="bottom"
    [mdbPopover]="content"
    (popoverShown)="onPopoverShown()"
    (popoverHidden)="onPopoverHidden()"
    trigger="click"
    #popover="mdbPopover"
>
    <img class='mdb-popover' src="/img/svg/virtual-event/actions.svg"/>
</button>

<ng-template #content>
  <div class="popover-links popover-links--aligned">
    <ng-container *ngIf="campaign.type === CAMPAIGN_TYPE.AUCTION">
        <div
            *ngIf="!isProduction"
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            (click)="resetAuctionData(campaign)"
        >
            <i class="fas fa-eraser mr-2"></i>
            <div>Reset Auction Data</div>
        </div>
    </ng-container>
    <ng-container *ngIf="campaign.type === CAMPAIGN_TYPE.LAST_HERO">
        <div
            *ngIf="!isProduction"
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            (click)="clearLastHeroWinner(campaign)"
        >
            <i class="fas fa-eraser mr-2"></i>
            <div>Clear Last Hero Winner</div>
        </div>
    </ng-container>
    <ng-container *ngIf="campaign.type === CAMPAIGN_TYPE.TICKETING">
        <div
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            (click)="onClickInvite(campaign)"
        >
            <i class="fas fa-paper-plane mr-2"></i>
            <div>Send Invitations</div>
        </div>
    </ng-container>
    <div
        class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
        (click)="onClickReport(campaign)"
    >
        <i class="far fa-chart-bar mr-2"></i>
        <div>Report</div>
    </div>
    <ng-container *ngIf="campaign.type === CAMPAIGN_TYPE.AUCTION">
      <div
          class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
          (click)="onClickCopyAuction(campaign)"
      >
          <i class="far fa-clone mr-2"></i>
          <div>Copy...</div>
      </div>
    </ng-container>

    <ng-container *ngIf="campaign.type !== CAMPAIGN_TYPE.AUCTION">
      <div
        class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
        (click)="onClickCopy(campaign)"
      >
        <i class="far fa-clone mr-2"></i>
        <div>Copy</div>
      </div>
    </ng-container>
    <ng-container *ngIf="showDrawWinner">
        <div
            class="popover__action popover__action--border d-flex align-items-center cursor-pointer px-2"
            (click)="onClickRaffleDraw(campaign)"
        >
            <i class="fas fa-trophy mr-2"></i>
            <div>Draw Winner</div>
        </div>
    </ng-container>
    <ng-container *ngIf="campaign.status < 5">
        <div
            class="popover__action d-flex align-items-center cursor-pointer px-2"
            (click)="archiveCampaign(campaign)"
        >
            <i class="fa fa-archive mr-2"></i>
            <div>Archive</div>
        </div>
    </ng-container>
  </div>
</ng-template>
